/**
 * moodz-cart-drawer-sync.js
 * – Anime la progress bar
 * – Ajoute / retire automatiquement le cadeau MyMOODz
 * – Sync totaux / footer
 *
 * Principe : après add/remove, on délègue le re-render à cart.js
 * via publish(PUB_SUB_EVENTS.cartUpdate) → pas de conflit DOM.
 */
(function () {
  'use strict';

  var DEBOUNCE_MS    = 350;
  var _timer         = null;
  var _running       = false;
  var lastFillWidth  = null;

  // ── État cadeau ────────────────────────────────────────────────────────
  var _giftProcessing = false;
  var _prevGiftInCart = {};  // { variantId: true | false | undefined }
  var _prevCartTotal  = -1;
  var _giftCheckTimer = null;

  // ── Progress bar animation ────────────────────────────────────────────
  function animateFill(fill) {
    var target = fill.style.width;
    if (!target) return;
    var from = lastFillWidth || '0%';
    if (from === target) { lastFillWidth = target; return; }
    fill.style.transition = 'none';
    fill.style.width = from;
    fill.getBoundingClientRect();
    requestAnimationFrame(function () {
      fill.style.removeProperty('transition');
      fill.style.width = target;
    });
    lastFillWidth = target;
  }

  // ── Délègue le re-render à cart.js ───────────────────────────────────
  // publish(PUB_SUB_EVENTS.cartUpdate) sans sections déclenche onCartUpdate()
  // dans cart-drawer.js → updateCartDrawer() → cartSectionsList complet.
  function triggerCartRefresh() {
    if (typeof window.publish === 'function'
        && window.PUB_SUB_EVENTS
        && window.PUB_SUB_EVENTS.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'moodz-gift' });
      return;
    }
    // Fallback : forcer onCartUpdate sur l'élément cart-drawer-items
    var cartItems = document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    }
  }

  // ── Gift : add ────────────────────────────────────────────────────────
  function addGift(variantId) {
    if (_giftProcessing) return;
    _giftProcessing = true;
    _prevGiftInCart[String(variantId)] = true;
    console.log('[MOODZ-GIFT] addGift →', variantId);

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { 'Cadeau': 'Offert' } })
    })
    .then(function (r) {
      if (!r.ok) {
        console.error('[MOODZ-GIFT] /cart/add.js HTTP', r.status);
        _prevGiftInCart[String(variantId)] = false;
      } else {
        console.log('[MOODZ-GIFT] /cart/add.js OK');
      }
      return r.json();
    })
    .then(function () { triggerCartRefresh(); })
    .catch(function (e) {
      console.error('[MOODZ-GIFT] addGift error:', e);
      _prevGiftInCart[String(variantId)] = false;
    })
    .finally(function () {
      setTimeout(function () { _giftProcessing = false; }, 1200);
    });
  }

  // ── Gift : remove ─────────────────────────────────────────────────────
  function removeGift(itemKey, variantId) {
    if (_giftProcessing) return;
    _giftProcessing = true;
    if (variantId) _prevGiftInCart[String(variantId)] = false;
    console.log('[MOODZ-GIFT] removeGift →', itemKey);

    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(function () { triggerCartRefresh(); })
    .catch(function (e) { console.error('[MOODZ-GIFT] removeGift error:', e); })
    .finally(function () {
      setTimeout(function () { _giftProcessing = false; }, 1200);
    });
  }

  // ── Logique principale ────────────────────────────────────────────────
  function checkGiftAutoAdd() {
    if (_giftProcessing) return;

    var wrapper = document.getElementById('moodz-gift-progress-drawer');
    if (!wrapper || wrapper.getAttribute('data-auto-add') !== 'true') return;

    var cartTotal   = parseInt(wrapper.getAttribute('data-cart-total')  || '0', 10);
    var gifts = [
      { variantId: wrapper.getAttribute('data-gift-1-variant-id'),
        threshold:  parseInt(wrapper.getAttribute('data-threshold-1')  || '0', 10) },
      { variantId: wrapper.getAttribute('data-gift-2-variant-id'),
        threshold:  parseInt(wrapper.getAttribute('data-threshold-2')  || '0', 10) }
    ];

    // totalChanged : permet de détecter une suppression manuelle du cadeau
    // (le total ne change pas quand on retire un produit gratuit)
    var totalChanged = (cartTotal !== _prevCartTotal);
    console.log('[MOODZ-GIFT] check cartTotal:', cartTotal,
      'prev:', _prevCartTotal, 'totalChanged:', totalChanged);

    fetch('/cart.js?_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (_giftProcessing) return;

        gifts.forEach(function (gift) {
          if (!gift.variantId || gift.variantId === '0' || gift.threshold === 0) return;

          var matchingItem = cart.items.find(function (item) {
            return String(item.variant_id) === String(gift.variantId)
              && item.properties && item.properties['Cadeau'] === 'Offert';
          });
          var inCart    = !!matchingItem;
          var wasInCart = _prevGiftInCart[String(gift.variantId)];

          console.log('[MOODZ-GIFT] variant:', gift.variantId,
            'threshold:', gift.threshold, 'inCart:', inCart, 'wasInCart:', wasInCart);

          if (cartTotal >= gift.threshold && !inCart) {
            if (wasInCart === true && !totalChanged) {
              // Suppression manuelle : total inchangé + cadeau disparu → ne pas re-ajouter
              console.log('[MOODZ-GIFT] suppression manuelle détectée, skip');
              _prevGiftInCart[String(gift.variantId)] = false;
            } else {
              addGift(gift.variantId);
            }
          } else if (cartTotal < gift.threshold && inCart) {
            removeGift(matchingItem.key, gift.variantId);
          } else {
            _prevGiftInCart[String(gift.variantId)] = inCart;
          }
        });

        _prevCartTotal = cartTotal;
      })
      .catch(function (e) { console.error('[MOODZ-GIFT] /cart.js error:', e); });
  }

  function scheduleGiftCheck(delay) {
    clearTimeout(_giftCheckTimer);
    _giftCheckTimer = setTimeout(checkGiftAutoAdd, delay || 400);
  }

  // ── MutationObserver : animation + déclenchement cadeau ───────────────
  function initProgressObserver() {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');
    if (!drawer) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {

        // Sauvegarder la largeur avant suppression (animation)
        mutation.removedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          var oldFill = node.matches && node.matches('[data-moodz-gift-progress-fill]')
            ? node : (node.querySelector ? node.querySelector('[data-moodz-gift-progress-fill]') : null);
          if (oldFill && oldFill.style.width) lastFillWidth = oldFill.style.width;
        });

        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          // Animation fill
          if (node.matches && node.matches('[data-moodz-gift-progress-fill]')) animateFill(node);
          (node.querySelectorAll ? node.querySelectorAll('[data-moodz-gift-progress-fill]') : [])
            .forEach(animateFill);

          // Déclenchement du check cadeau quand #CartDrawer-CartItems est re-rendu
          // (cart.js vient de terminer sa mise à jour → données fraîches)
          var isCartItems = (node.id === 'CartDrawer-CartItems');
          var hasCartItems = !isCartItems && node.querySelector
            && !!node.querySelector('#CartDrawer-CartItems');

          if (isCartItems || hasCartItems) {
            // cart.js vient de remplacer les items → on vérifie le cadeau
            if (!_giftProcessing) scheduleGiftCheck(300);
          }
        });
      });
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  // ── Sync totaux / footer ──────────────────────────────────────────────
  function schedule() {
    clearTimeout(_timer);
    _timer = setTimeout(run, DEBOUNCE_MS);
  }

  async function run() {
    if (_running) { _timer = setTimeout(run, DEBOUNCE_MS); return; }
    _running = true;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var res  = await fetch(root + 'cart?sections=cart-drawer', {
        headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
      });
      if (!res.ok) return;
      var data = await res.json();
      var html = data && data['cart-drawer'];
      if (!html) return;

      var parser  = new DOMParser();
      var newDoc  = parser.parseFromString(html, 'text/html');
      var newRoot = newDoc.querySelector('#CartDrawer') || newDoc.body;

      var curTotals = document.querySelector('#CartDrawer .gb-discounts-cart-values, cart-drawer .gb-discounts-cart-values');
      var newTotals = newRoot.querySelector('.gb-discounts-cart-values');
      if (curTotals && newTotals) curTotals.innerHTML = newTotals.innerHTML;

      var curFooter = document.querySelector('#CartDrawer .cart-drawer__footer, cart-drawer .cart-drawer__footer');
      var newFooter = newRoot.querySelector('.cart-drawer__footer');
      if (curFooter && newFooter && !curTotals) curFooter.innerHTML = newFooter.innerHTML;

      if (typeof window.MOODZ_UPSELL_REFRESH === 'function') {
        setTimeout(function () { try { window.MOODZ_UPSELL_REFRESH(); } catch (e) {} }, 80);
      }
    } catch (e) {} finally { _running = false; }
  }

  // ── Listeners ─────────────────────────────────────────────────────────
  function attachListeners() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.quantity__button') ||
          e.target.closest('cart-remove-button') ||
          e.target.closest('.upsell-add-button') ||
          e.target.closest('[data-upsell-add-to-cart]')) { schedule(); }
    }, { passive: true });

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.quantity__input')) schedule();
    });

    // ATC depuis la PDP → renderContents a fini à ~600ms
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        schedule();
        // Ne pas re-checker si c'est nous qui venons de publier
        if (event && event.source === 'moodz-gift') return;
        scheduleGiftCheck(700);
      });
    }
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh',  schedule);

    initProgressObserver();

    // Check initial (panier déjà chargé côté serveur au page load)
    var existing = document.getElementById('moodz-gift-progress-drawer');
    console.log('[MOODZ-GIFT] init wrapper:', !!existing,
      existing ? 'cartTotal=' + existing.getAttribute('data-cart-total')
        + ' variant=' + existing.getAttribute('data-gift-1-variant-id')
        + ' threshold=' + existing.getAttribute('data-threshold-1') : '');
    if (existing) setTimeout(checkGiftAutoAdd, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();
